import React, { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Tooltip, Typography
} from '@material-ui/core';
import { useAuth } from "../../context/auth";

function TerminalComponent({ feature, type, csvLookup }) {
  const [open, setOpen] = useState(false);
  const [csvDialogOpen, setCsvDialogOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const { extendedOverlayAccess } = useAuth(); 

  // Normalize GeoJSON features vs raw CSV rows
  const properties = feature?.properties ?? feature;

  const objectId = Number(properties?.OBJECTID);
  const matchedCsv = (csvLookup && type === 'product') ? csvLookup[objectId] : null;

  const renderProperties = () => {
    return Object.entries(properties).map(([key, value]) => (
      <Typography key={key}>
        <strong>{key}:</strong> {value !== null && value !== undefined ? value : 'N/A'}
      </Typography>
    ));
  };

  const renderCsvProperties = (csvRow) => {
    if (!csvRow) return null;
    return Object.entries(csvRow)
      .filter(([_, value]) => value !== null && value !== undefined && String(value).trim() !== '')
      .map(([key, value], index) => (
        <Typography key={`csv-${index}`} variant="body2">
          <strong>{key}:</strong> {String(value)}
        </Typography>
      ));
  };

  const renderTooltip = () => {
    if (type === 'product') {
      return <Typography>Company: {properties?.Company ?? 'N/A'}</Typography>;
    } else if (type === 'intermodal') {
      return <Typography>TERM_NAME: {properties?.TERM_NAME ?? 'N/A'}</Typography>;
    } else if (type === 'docks') {
      return <Typography>NAV_UNIT_NAME: {properties?.NAV_UNIT_NAME ?? 'N/A'}</Typography>;
    }
    return null;
  };

  const getMarkerStyle = () => {
    let backgroundColor;

    //  only show matched purple marker if user has extendedOverlayAccess
    if (type === 'product' && matchedCsv && extendedOverlayAccess === 1) {
      backgroundColor = '#800080'; // purple for matched CSV
    } else {
      switch (type) {
        case 'docks':
          backgroundColor = '#1E90FF'; // blue
          break;
        case 'product':
          backgroundColor = '#32CD32'; // green
          break;
        case 'intermodal':
          backgroundColor = '#FFA500'; // orange
          break;
        default:
          backgroundColor = '#1E90FF';
      }
    }

    return {
      backgroundColor,
      width: isHovered ? '14px' : '7px',
      height: isHovered ? '14px' : '7px',
      display: 'inline-block',
      borderRadius: '50%',
      zIndex: 4,
      transition: 'width 0.3s, height 0.3s',
      cursor: 'pointer',
      border: '1px solid #B9B4B3',
      boxShadow: isHovered ? '0 0 8px rgba(0,0,0,0.3)' : 'none',
    };
  };

  return (
    <div>
      <Tooltip title={renderTooltip()}>
        <div
          style={getMarkerStyle()}
          onClick={() => setOpen(true)}
          onMouseOver={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        />
      </Tooltip>

      {/* Main Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Terminal Details</DialogTitle>
        <DialogContent>{renderProperties()}</DialogContent>
        <DialogActions>
          {/*  Only show “More Info” if they have extendedOverlayAccess */}
          {extendedOverlayAccess === 1 && matchedCsv && (
            <Button color="secondary" onClick={() => setCsvDialogOpen(true)}>
              More Info
            </Button>
          )}
          <Button onClick={() => setOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/*  CSV Dialog (hidden unless user has extended access) */}
      {extendedOverlayAccess === 1 && matchedCsv && (
        <Dialog open={csvDialogOpen} onClose={() => setCsvDialogOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle>CSV Info for Terminal #{objectId}</DialogTitle>
          <DialogContent>{renderCsvProperties(matchedCsv)}</DialogContent>
          <DialogActions>
            <Button onClick={() => setCsvDialogOpen(false)} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}

function areEqual(prevProps, nextProps) {
  return prevProps.id === nextProps.id &&
         prevProps.lat === nextProps.lat &&
         prevProps.lng === nextProps.lng;
}

export default React.memo(TerminalComponent, areEqual);
